import { CODESMITH_EXTENSION_ORIGIN } from "./codesmithExtensionCapture";

export const CODESMITH_EXTENSION_HISTORY_REQUEST =
  "codesmith-extension-history-request";
export const CODESMITH_EXTENSION_HISTORY_STATE =
  "codesmith-extension-history-state";

type NavigationResultLike = {
  committed: Promise<unknown>;
  finished: Promise<unknown>;
};

interface NavigationLike {
  canGoBack: boolean;
  canGoForward: boolean;
  back(): NavigationResultLike;
  forward(): NavigationResultLike;
  addEventListener(type: "currententrychange", listener: EventListener): void;
  removeEventListener(
    type: "currententrychange",
    listener: EventListener,
  ): void;
}

export function windowNavigation(): NavigationLike | null {
  const browserWindow = window as unknown as {
    navigation?: NavigationLike;
  };
  return browserWindow.navigation ?? null;
}

// Both promises reject when a traversal is refused (e.g. one already in
// flight), and an unhandled `committed` rejection would surface as an error.
export function traverseNavigation(
  navigation: NavigationLike,
  direction: "back" | "forward",
): void {
  if (direction === "back" && !navigation.canGoBack) return;
  if (direction === "forward" && !navigation.canGoForward) return;
  const result = navigation[direction]();
  void result.committed.catch(() => {});
  void result.finished.catch(() => {});
}

export function parseCodesmithExtensionHistoryRequest(
  event: MessageEvent,
): "back" | "forward" | null {
  if (
    event.source !== window.parent ||
    event.origin !== CODESMITH_EXTENSION_ORIGIN ||
    !event.data ||
    typeof event.data !== "object"
  ) {
    return null;
  }

  const data = event.data as Record<string, unknown>;
  if (data.type !== CODESMITH_EXTENSION_HISTORY_REQUEST) return null;
  return data.direction === "back" || data.direction === "forward"
    ? data.direction
    : null;
}

export function postCodesmithExtensionHistoryState(navigation: {
  canGoBack: boolean;
  canGoForward: boolean;
}): void {
  window.parent.postMessage(
    {
      type: CODESMITH_EXTENSION_HISTORY_STATE,
      canGoBack: navigation.canGoBack,
      canGoForward: navigation.canGoForward,
    },
    CODESMITH_EXTENSION_ORIGIN,
  );
}
